import uri from 'urijs';
import { createAction, USER_ID_TYPE_USER, USER_ID_TYPE_SITE_MEMBER } from '@wix/communities-blog-client-common';
import { buildPaginationRequestParams, getTotalResults } from '../services/pagination';

export const FETCH_USER_LIKES_REQUEST = 'userLikes/FETCH_REQUEST';
export const FETCH_USER_LIKES_SUCCESS = 'userLikes/FETCH_SUCCESS';
export const FETCH_USER_LIKES_FAILURE = 'userLikes/FETCH_FAILURE';

export const fetchProfileLikesRequest = createAction(
  FETCH_USER_LIKES_REQUEST,
  (payload) => payload,
  (payload, meta) => meta
);
export const fetchProfileLikesSuccess = createAction(
  FETCH_USER_LIKES_SUCCESS,
  (payload) => payload,
  (payload, meta) => meta
);
export const fetchProfileLikesFailure = createAction(
  FETCH_USER_LIKES_FAILURE,
  (payload) => payload,
  (payload, meta) => meta
);

function fetchLikes({ userIdType = USER_ID_TYPE_USER, id, page, pageSize }) {
  return async (dispatch, _, { request, requestFromSocialBlog }) => {
    dispatch(fetchProfileLikesRequest({ userIdType, id }));

    const settingsResponse = await requestFromSocialBlog('/_api/blog-settings-service/v2/blog-settings');
    const isCommentingEnabled = settingsResponse.blogSettings.comments.enabled;

    if (settingsResponse.blogSettings.useBlogLikeService) {
      const likesResponse = await requestFromSocialBlog.post('/_api/blog-like-service/v1/likes/query', {
        query: { filter: { fqdn: { $eq: 'wix.blog.v3.post' } } },
      });
      const postIds = likesResponse.likes.map((like) => like.entityId);

      const postsResponse = await requestFromSocialBlog.post('/_api/communities-blog-node-api/v3/posts/query', {
        query: { filter: { id: { $in: postIds } } },
        fieldsets: ['METRICS'],
      });

      return dispatch(
        fetchProfileLikesSuccess(
          postsResponse.posts.map((post) => ({
            ...post,
            _id: post.id,
            isCommentingEnabled,
            viewCount: post.metrics.views,
            totalComments: post.metrics.comments,
            likeCount: post.metrics.likes,
            isLiked: true,
            showProfileImage: false,
            type: 'post',
            coverImage: {
              imageMetadata: {
                id: post?.media?.wixMedia?.image?.id,
                file_name: post?.media?.wixMedia?.image?.filename,
                height: post?.media?.wixMedia?.image?.height,
                width: post?.media?.wixMedia?.image?.width,
              },
              isEnabled: post?.media?.displayed,
            },
          })),
          { count: postsResponse?.pagingMetadata?.total, page }
        )
      );
    } else {
      const params = buildPaginationRequestParams(page, pageSize);
      const promise = request(uri(`/_api/likes/${userIdType}/${id}`).query(params), { parseHeaders: true });

      return promise
        .then(({ body = [], headers = {} }) =>
          dispatch(
            fetchProfileLikesSuccess(body, {
              isCommentingEnabled,
              count: getTotalResults(headers),
              page,
            })
          )
        )
        .catch(() => dispatch(fetchProfileLikesFailure({ userIdType, id })))
        .then(() => promise);
    }
  };
}

export function fetchLikesBySiteMemberId({ id, page, pageSize }) {
  return fetchLikes({ userIdType: USER_ID_TYPE_SITE_MEMBER, id, page, pageSize });
}
